import React from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router';

import style from './style.module.less';
import { apiDispatchAuthInformation } from '@/api/dispatch/auth';
import { context } from '@/common/context';
import { PageContent } from '@/common/layout/admin/components/page-content';
import { SideBar } from '@/common/layout/admin/components/side-bar';
import { defaultTimezone } from '@/config/country';
import { useSettingsStore } from '@/stores/settings';

/**
 * AI.GEN lines=1-35
 * 管理后台布局组件 - 应用缩放功能
 */
export const LayoutAdmin = () => {
  const location = useLocation();
  const zoom = useSettingsStore((state) => state.zoom);

  // 应用缩放功能
  React.useEffect(() => {
    const docEl = document.documentElement;
    docEl.style.cssText = `zoom:${zoom}%`;
  }, [zoom]);

  // 获取用户信息
  React.useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const res = await apiDispatchAuthInformation();
        // 存储扩展用户信息到 context
        context.user.setExtendedUserInfo({
          userNick: res.userNick ?? null,
          hpType: res.hpType ?? null,
          pfType: res.pfType ?? null,
          timeZone: defaultTimezone,
          cities: null, // 该接口不返回城市列表
        });
      } catch (error) {
        // 静默失败，使用缓存数据
      }
    };

    // 每次组件挂载时都获取用户信息（确保数据是最新的）
    fetchUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={style.reactAdmin}>
      {!location.search.includes('sourceSiteUri=1') ? (
        <>
          <SideBar></SideBar>
          <div className={classNames(style.content, 'flex-column')}>
            <PageContent></PageContent>
          </div>
        </>
      ) : (
        <PageContent></PageContent>
      )}
    </div>
  );
};
